import { render } from "./ResetPassword.vue?vue&type=template&id=b83aee24"
import script from "./ResetPassword.vue?vue&type=script&lang=ts"
export * from "./ResetPassword.vue?vue&type=script&lang=ts"
script.render = render

export default script